import React, { useRef, useState } from "react";
import useStorage from "shared/hooks/useStorage";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

const useStudentActivity = (student_uid:string) => {
    const { getBranchId } = useGetBranchId();
    const { uploadStorage } = useStorage();
    const { writeFirestore } = useFirestore();
    const videoInputRef = useRef<HTMLInputElement>(null);
    const [showLoading, setShowLoading] = useState(false);
    const [uploadProgerss, setUploadProgress] = useState(0);
    const [isError, setIsError] = useState(false);
    const [isSucceed, setIsSucceed] = useState(false);
    const [showNullModal, setShowNullModal] = useState(false);
    const [inputs, setInputs] = useState({
        title:"",
        contents:""
    })

    const [video, setVideo] = useState<File>()
    const [videoURL, setVideoURL] = useState<string | null>(null);

    const onChange = (e:React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const {name, value} = e.target;
        setInputs({
            ...inputs,
            [name]:value
        })
    }

    const onVideoInputClick = () => {
        if(videoInputRef.current !== null){
            videoInputRef.current.click();
        }
    }

    const onFileInput = (e:React.ChangeEvent<HTMLInputElement>) => {
        if(e.target.files !== null){
            setVideo(e.target.files[0]);
            const objectURL = URL.createObjectURL(e.target.files[0]);
            setVideoURL(objectURL);
        }
    }

    const onSaveClick = async() => {
        const branch_id = await getBranchId();
        const now = new Date();
        if(!(video && inputs.title)){
            setShowNullModal(true);
            return;
        }
        setShowLoading(true);
        const video_url = await uploadStorage(`Activity/${student_uid}`, video, setUploadProgress).then(res => {
            return res;
        })
        setShowLoading(false);
        const data = {
            title:inputs.title,
            contents:inputs.contents,
            video:video_url
        }
        await writeFirestore(`Activity/${branch_id}/${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}`, student_uid, data).then(res => {
            if(res){
                setIsSucceed(true);
                return;
            }
            setIsError(true);
        })
    }

    return{inputs, onChange, videoInputRef, onVideoInputClick, onFileInput, videoURL, onSaveClick, 
        showNullModal, setShowNullModal, uploadProgerss, showLoading,
    isSucceed, setIsSucceed, isError, setIsError}
}

export default useStudentActivity;